import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { NZ_I18N, en_US } from 'ng-zorro-antd/i18n';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';

import { registerLocaleData, PathLocationStrategy, LocationStrategy, DatePipe } from '@angular/common';
import en from '@angular/common/locales/en';

import { AppRoutingModule } from './app-routing.module';
import { TemplateModule } from './shared/template/template.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { CommonLayoutComponent } from './layouts/common-layout/common-layout.component';
import { FullLayoutComponent } from './layouts/full-layout/full-layout.component';

import { NgChartjsModule } from 'ng-chartjs';
import { ThemeConstantService } from './shared/services/theme-constant.service';
import { ReactiveFormsModule } from '@angular/forms';
import { LoginService } from './shared/services/login.service';
import { QuillModule } from 'ngx-quill';
import { WebService } from './shared/services/web.service';
import {AwsService} from './shared/services/aws-service'
import { MetaDataService } from './shared/services/metadata.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { TUI_LANGUAGE, TUI_ENGLISH_LANGUAGE } from '@taiga-ui/i18n';
// import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { ResourceDetailModule } from './resource-detail/resource-detail.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import {JwtInterceptor } from './shared/interceptor/token.interceptor';
import {AuthenticationService} from './shared/services/authentication.service';
// import { MessageComponent } from './message/message.component';

// import { NgxDocViewerModule } from 'ngx-doc-viewer';
// import { ResourceDetailModule } from './resource-detail/resource-detail.module';
// import { NgxSpinnerModule } from 'ngx-spinner';
registerLocaleData(en);

@NgModule({
    declarations: [
        AppComponent,
        CommonLayoutComponent,
        FullLayoutComponent,
        // MessageComponent,
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NzBreadCrumbModule,
        TemplateModule,
        SharedModule,
        NgChartjsModule,
        ReactiveFormsModule,
        QuillModule.forRoot(),
        NzModalModule,
        NzToolTipModule,
        // NgxDocViewerModule,
        ResourceDetailModule,
        HttpClientModule,
       
    ],
    providers: [
        
        { 
            provide: NZ_I18N,
            useValue: en_US, 
        },
        {
            provide: LocationStrategy, 
            useClass: PathLocationStrategy
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor    ,
            multi: true // 'multi' is required to allow multiple interceptors
        },
        AuthenticationService,
        ThemeConstantService,
        WebService,
        LoginService,
        AwsService,
        MetaDataService,
        DatePipe,
        {
            provide: TUI_LANGUAGE,
            useValue: TUI_ENGLISH_LANGUAGE,
        },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
